import * as firebase from "firebase";

const fcmConfig = {
  apiKey: "AIzaSyAVm_Z9LUicLGt3HXfxOinFylCw7D5NBmk",
  authDomain: "moca-notification.firebaseapp.com",
  databaseURL: "https://moca-notification.firebaseio.com",
  projectId: "moca-notification",
  storageBucket: "moca-notification.appspot.com",
  messagingSenderId: "466997746174",
  appId: "1:466997746174:web:351ea9297c04c62536c8af",
  measurementId: "G-Y8XKRJ9J20"
};

export default firebase.initializeApp(fcmConfig);
